import * as React from 'react';

interface IHelpLinkProps extends React.PropsWithChildren {
	to: string;
	target?: string;
}

export const HelpLink: React.FC<IHelpLinkProps> = ({ to, target, children }) => {
	return <div className="help-link">
		<a className="help-link__a" href={to} target={target || '_blank'}>
			<span className="help-link__icon">?</span>
			<span className="help-link__content">{children}</span>
		</a>
	</div>;
};
